import * as React from 'react'

import { ProductPageData } from '@thg-commerce/enterprise-aurora-product/resolvers/ProductPage/types'
import { i18n, useSiteConfig } from '@thg-commerce/enterprise-core'
import { ProductVariantWithDescription } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/Product'
import { ProductSummaryOrder } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { TextStyling } from '@thg-commerce/gravity-theme'

import { ExternalIdentifierDisplayContainer } from './styles'

const stripSizeFromExternalIdentifier = (
  externalIdentifier: string | null | undefined,
  product?: ProductPageData,
) => {
  if (product?.externalIdentifier) {
    const productLength = product.externalIdentifier?.length
    return externalIdentifier?.slice(0, productLength)
  }
  if (!externalIdentifier) {
    return null
  }
  return externalIdentifier
}

export const ExternalIdentifierDisplay = ({
  product,
  selectedVariant,
  textStyle,
  order,
}: {
  product: ProductPageData
  selectedVariant: ProductVariantWithDescription
  textStyle?: TextStyling
  order?: ProductSummaryOrder
}) => {
  const {
    showExternalIdentifierInProductSummary,
    showOnlyProductSKU,
  } = useSiteConfig()
  const externalIdentifierDisplayLabel = i18n(
    'general.externalidentifierdisplay.text',
  )

  const baseExternalIdentifier = selectedVariant?.externalIdentifier
    ? stripSizeFromExternalIdentifier(
        selectedVariant.externalIdentifier,
        product,
      )
    : product.externalIdentifier

  const externalIdentifier = showOnlyProductSKU
    ? baseExternalIdentifier
    : product.externalIdentifier

  if (externalIdentifier && showExternalIdentifierInProductSummary) {
    return (
      <ExternalIdentifierDisplayContainer order={order} textStyle={textStyle}>
        {`${externalIdentifierDisplayLabel}${externalIdentifier}`}
      </ExternalIdentifierDisplayContainer>
    )
  }

  return null
}
